import { handleRequest } from ".";
import { httpAuthorized } from "@/main";

/**
 * 获取协议 TEXT 枚举映射 {dataId: ["中文|English", ...]}
 *
 * <p>前端启动时加载缓存，页面展示工况/电池状态等枚举值时用 resolveProtocolText() 翻译。
 * TEXT 数组格式为 "中文|English"，按 locale 取对应部分。</p>
 */
export const getProtocolTextApi = async (): Promise<Record<
  string,
  string[]
> | null> => {
  return handleRequest<Record<string, string[]>>(
    httpAuthorized.get("/translation/protocolText"),
    (data) => data.data
  );
};
